module.exports = __webpack_public_path__ + "img/mo.e1178856.svg";